module.exports = __webpack_public_path__ + "img/SDG-17-EN-INVERTED.080705db.png";